import { API } from "./api";

// Auth helper functions
export const getAuthHeaders = (token: string) => ({
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
});

// Prevent multiple concurrent redirects to login
let isRedirectingToLogin = false;

export function handleExpiredSession() {
    if (isRedirectingToLogin) return;
    isRedirectingToLogin = true;
    localStorage.removeItem("tv_token");
    window.location.href = "/login?session=expired";
}

// Generic fetch wrapper with error handling
export async function fetchWithAuth<T>(
    endpoint: string,
    token: string,
    options?: RequestInit
): Promise<T> {
    const url = `${API}${endpoint}`;
    const headers = getAuthHeaders(token);

    const response = await fetch(url, {
        ...options,
        headers: {
            ...options?.headers,
            ...headers,
        },
    });

    if (!response.ok) {
        if (response.status === 401) {
            handleExpiredSession();
            // Throw so callers don't proceed with undefined data
            throw new Error("Session expired");
        }
        const text = await response.text();
        throw new Error(text || `API error: ${response.status}`);
    }

    return response.json();
}
